(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3673,64],{

/***/ 40336:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/product-listing",
      function () {
        return __webpack_require__(32020);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 50064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ v2_ProductList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
;// CONCATENATED MODULE: ./i18n/useProductListi18n.js

const useProductListi18n = (param)=>{
    let { componentProps , total , generalRef  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    var _noResultsMsg;
    const i18n = {
        expanded: t("kf.productTab.aria.expanded"),
        collapsed: t("kf.productTab.aria.collapsed"),
        totalCount: t("kf.plp.label.totalCount", {
            count: total
        }),
        hideFilterAria: t("kf.plp.label.hideFilterAria"),
        showFilterAria: t("kf.plp.label.showFilterAria"),
        clearAllAria: t("kf.plp.label.clearAllAria"),
        listWith: t("kf.plp.label.listWith"),
        items: t("kf.plp.label.items"),
        facetListAriaExpandOrCollapse: t("kf.plp.label.facetListAriaExpandOrCollapse"),
        showMoreFiltersAria: t("kf.plp.label.showMoreFiltersAria"),
        sortByAria: (count)=>t("kf.plp.label.sortByAria", {
                sortByCount: count
            }),
        sortBykey: t("kf.plp.label.sortBykey"),
        salePriceAria: t("kf.plp.label.salePriceAria"),
        originalPriceAria: t("kf.plp.label.originalPriceAria"),
        productDescription: t("kf.plp.label.productDescription"),
        colorsLinkAria: t("kf.plp.label.colorsLinkAria"),
        pageTitleAria: t("kf.plp.label.pageTitleAria", {
            categoryName: componentProps.categoryKey,
            brandName: generalRef === null || generalRef === void 0 ? void 0 : generalRef.brandName
        }),
        print: t("kf.plp.label.print"),
        share: t("kf.plp.label.share"),
        wishlist: t("kf.plp.label.wishlist"),
        showFilter: t("kf.plp.label.showFilter"),
        hideFilter: t("kf.plp.label.hideFilter"),
        showFilterState: t("kf.plp.label.showFilterState"),
        hideFilterState: t("kf.plp.label.hideFilterState"),
        filters: t("kf.plp.label.filters"),
        filterSort: t("kf.plp.label.filterSort"),
        listviewFilter: t("kf.plp.label.listViewDeclare"),
        addToCompare: t("kf.plp.label.addToCompare"),
        colors: t("kf.plp.label.colors"),
        color: t("kf.plp.label.color"),
        view: t("kf.plp.label.view"),
        all: t("kf.plp.label.all"),
        gridView: t("kf.plp.label.gridView"),
        columnView: t("kf.plp.label.columnView"),
        sort: t("kf.plp.label.sort"),
        sortbyExpanded: t("kf.plp.label.sortbyExpanded"),
        sortbyClosed: t("kf.plp.label.sortbyClosed"),
        selected: t("kf.plp.arialabel.selected"),
        altSort: t("kf.plp.label.img.altSort"),
        applyFilters: "Apply Filters",
        results: t("kf.plp.label.results"),
        annsacksResults: t("kf.plp.label.annsacksResults"),
        loadMore: t("kf.plp.label.loadMore"),
        backToTop: t("kf.plp.label.backToTop"),
        showMore: componentProps.isAnnsacksPlp ? t("annsacks.plp.label.showMore") : t("kf.plp.label.showMore"),
        showLess: componentProps.isAnnsacksPlp ? t("annsacks.plp.label.showLess") : t("kf.plp.label.showLess"),
        clearAll: t("kf.plp.label.clearAll"),
        priceRangeTitle: t("kf.plp.label.priceRangeTitle"),
        priceRangeDesc: t("kf.plp.label.priceRangeDesc"),
        to: t("kf.plp.label.to"),
        minText: t("kf.plp.label.minText"),
        maxText: t("kf.plp.label.maxText"),
        sameCategory: componentProps.sameCategory ? componentProps.sameCategory : t("kf.compare.validation.sameCategory"),
        maxProduct: componentProps.maxProduct ? componentProps.maxProduct : t("kf.compare.validation.maxProducts"),
        favSuccessMsg: t("kf.favorites.success"),
        favErrorMsg: t("kf.favorites.error"),
        errors: {
            validRange: t("kf.plp.error.validRange"),
            minGreaterThanMax: t("kf.plp.error.minGreaterThanMax"),
            maxGreaterThanZero: t("kf.plp.error.maxGreaterThanZero"),
            checkValid: t("kf.error.message.price")
        },
        ariaLabel: {
            columnViewSelected: t("kf.productTab.aria.columnViewSelected"),
            columnViewNotSelected: t("kf.productTab.aria.columnViewNotSelected"),
            gridViewSelected: t("kf.productTab.aria.gridViewSelected"),
            gridViewNotSelected: t("kf.productTab.aria.gridViewNotSelected")
        },
        startingAt: t("kf.plp.label.startingAt"),
        viewResults: t("kf.plp.label.viewResults"),
        new: (generalRef === null || generalRef === void 0 ? void 0 : generalRef.badgeText.new) ? generalRef === null || generalRef === void 0 ? void 0 : generalRef.badgeText.new : t("kf.plp.label.new"),
        onSale: (generalRef === null || generalRef === void 0 ? void 0 : generalRef.badgeText.onSale) ? generalRef === null || generalRef === void 0 ? void 0 : generalRef.badgeText.onSale : t("kf.plp.label.onSale"),
        exclusive: (generalRef === null || generalRef === void 0 ? void 0 : generalRef.badgeText.exclusive) ? generalRef === null || generalRef === void 0 ? void 0 : generalRef.badgeText.exclusive : t("kf.plp.label.exclusive"),
        newExclusive: t("kf.plp.label.newExclusive"),
        filterOpenAlert: t("kf.plp.ariaLabel.filterOpenAlert"),
        filterCloseAlert: t("kf.plp.ariaLabel.filterCloseAlert"),
        removeItem: t("kf.favorites.removeItem"),
        removeItemError: t("kf.favorites.removeItemError"),
        noResultsMssg: (_noResultsMsg = componentProps.noResultsMsg) !== null && _noResultsMsg !== void 0 ? _noResultsMsg : t("kf.plp.label.noResultsMssg"),
        featured: t("kf.plp.label.featured"),
        // featured: "Featured",
        priceDesc: t("kf.plp.label.priceDesc"),
        priceAsc: t("kf.plp.label.priceAsc"),
        atoz: t("kf.plp.label.atoz"),
        ztoa: t("kf.plp.label.ztoa"),
        // extras
        newToOld: t("kf.myProducts.sort.newToOld"),
        oldToNew: t("kf.myProducts.sort.oldToNew"),
        // needtoCheck check in getSelectedSort helper.js
        AToZ: t("kf.services.sort.AToZ"),
        ZToA: t("kf.services.sort.ZToA"),
        filterTitle: (facetName, facetCount)=>t("kf.plp.ariaLabel.filterTitle", {
                facetName: facetName,
                facetCount: facetCount
            }),
        arialLabelPrint: t("kf.plp.label.aria.print"),
        ariaLabelShare: t("kf.plp.label.aria.share"),
        ariaLabelZeroResults: t("kf.pkp.ariaLabel.zeroResults"),
        ariaLabelFilteredResult: (totalResult)=>t("kf.plp.ariaLabel.filteredResult", {
                totalResult: totalResult
            }),
        ariaLabelFilteredResults: (totalResults)=>t("kf.plp.ariaLabel.filteredResults", {
                totalResults: totalResults
            }),
        ariaLabelAppliedFilter: t("kf.plp.ariaLabel.appliedFilter"),
        ariaLabelAppliedFilters: t("kf.plp.ariaLabel.appliedFilters")
    };
    return i18n;
};
/* harmony default export */ var i18n_useProductListi18n = (useProductListi18n);

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./components/ProductList/v2/Sort/index.module.scss
var index_module = __webpack_require__(19806);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./components/ProductList/v2/Filter/index.module.scss
var Filter_index_module = __webpack_require__(3899);
var Filter_index_module_default = /*#__PURE__*/__webpack_require__.n(Filter_index_module);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./components/ProductList/v2/ProductListView/index.module.scss
var ProductListView_index_module = __webpack_require__(29472);
var ProductListView_index_module_default = /*#__PURE__*/__webpack_require__.n(ProductListView_index_module);
// EXTERNAL MODULE: ./components/ProductList/v2/ProductTile/index.module.scss
var ProductTile_index_module = __webpack_require__(50702);
var ProductTile_index_module_default = /*#__PURE__*/__webpack_require__.n(ProductTile_index_module);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./store/features/productListSlice.js
var productListSlice = __webpack_require__(49682);
// EXTERNAL MODULE: ./hooks/usePrevious.js
var usePrevious = __webpack_require__(67166);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
;// CONCATENATED MODULE: ./components/ProductList/v2/analytics.js



const addAnalyticsShowEvent = function(promo, setPromoData) {
    let data = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    let promoData = promo.filter((promo)=>promo && promo.ctaLink);
    promoData.sort((a, b)=>a.position - b.position);
    promoData = getUniqueList(promoData, "position");
    let slot = 1;
    const component = [];
    promoData.forEach((promoItem)=>{
        let title = promoItem.desc || "";
        if (title) {
            var ref;
            const div = document.createElement("div");
            div.innerHTML = title;
            // This contains HTML code so remove some bugs here.
            title = (ref = div.innerText || div.textContent || "") === null || ref === void 0 ? void 0 : ref.toLowerCase();
            title = title.replace(/\n/g, "");
        }
        promoItem.componentInfo = {
            componentID: "".concat(window.location.origin).concat(promoItem.ctaLink),
            componentMessage: "promo-".concat(slot++),
            componentName: title,
            componentLocation: "plp:promo tiles",
            componentType: "internal campaign"
        };
        component.push({
            componentInfo: promoItem.componentInfo
        });
    });
    setPromoData({
        promos: promoData,
        isUpdate: false
    });
    if (!(0,helper.isShowAnalyticsEventLoaded)()) {
        const page = window.pageObj || {};
        page.user = (0,helper.getUserAnalyticsObject)();
        if (page.category) {
            page.category.room = data && data[0] && data[0].category1_s ? (0,helper.sanitizeTextForAnalytics)(data[0].category1_s) : "n/a";
        } else {
            page.category = {
                room: data && data[0] && data[0].category1_s ? (0,helper.sanitizeTextForAnalytics)(data[0].category1_s) : "n/a"
            };
        }
        if ((!page.user.gId || page.user.gId === "n/a") && (!page.user.commerceToolsID || page.user.commerceToolsID === "n/a")) {
            page.component = component;
            window.pageObj = page;
            window.isShowAnalyticsEvent = true;
        } else {
            window.adobeDataLayer.push({
                event: "cmp:show",
                page: page,
                component: component
            });
        }
    } else {
        var ref, ref1;
        const page1 = window.pageObj;
        page1.category.subCategoryName = (constants.SEAT_TYPES === null || constants.SEAT_TYPES === void 0 ? void 0 : constants.SEAT_TYPES.includes((ref = data[0]) === null || ref === void 0 ? void 0 : ref.Product_Category)) ? constants.SEAT_TYPES === null || constants.SEAT_TYPES === void 0 ? void 0 : constants.SEAT_TYPES.join(", ") : (ref1 = data[0]) === null || ref1 === void 0 ? void 0 : ref1.Product_Category;
    }
};
const getUniqueList = (arr, key)=>{
    return [
        ...new Map(arr.map((item)=>[
                item[key],
                item
            ])).values()
    ];
};
const getClickSignalPayload = (param)=>{
    let { highlightText , productCategory , siteName , sku , ...props } = param;
    const userInfo = window.adobeDataLayer.getState("page.user.authStatus") === "anonymous" ? "guest" : window.adobeDataLayer.getState("page.user.commerceToolsID");
    const sTimeStamp = new Date().toISOString().split("T")[0] + "T" + new Date().toTimeString().split(" ")[0] + "Z";
    return [
        {
            params: {
                query: highlightText !== null && highlightText !== void 0 ? highlightText : productCategory,
                app_id: siteName.toLowerCase(),
                doc_id: props.data.id,
                fusion_query_id: props.fusionQueryId,
                ctype: props.parent,
                user_id: userInfo,
                country: "USA",
                region: "Northeast",
                item_pos: props.index,
                plc: productCategory,
                sku_id: props.data.sku_s,
                session_id: props === null || props === void 0 ? void 0 : props.sessionId,
                count_i: "1",
                url: window.location
            },
            id: "".concat(new Date().valueOf(), "_").concat(userInfo, "_").concat(sku, " "),
            timestamp: sTimeStamp,
            type: "click"
        }
    ];
};
const triggerClickSignal = async (param)=>{
    let { highlightText , productCategory , siteName , sku , ...props } = param;
    const aSignalsPayload = getClickSignalPayload({
        highlightText,
        productCategory,
        siteName,
        sku,
        ...props
    });
    await apim.post("/search/signals/".concat(siteName.toLowerCase()), aSignalsPayload);
};


// EXTERNAL MODULE: ./utils/product.js
var product = __webpack_require__(29843);
// EXTERNAL MODULE: ./store/features/compareSlice.js
var compareSlice = __webpack_require__(39915);
// EXTERNAL MODULE: ./hooks/useIsSsr.js
var useIsSsr = __webpack_require__(2595);
// EXTERNAL MODULE: ./store/features/favoritesSlice.js + 1 modules
var favoritesSlice = __webpack_require__(7737);
// EXTERNAL MODULE: ./components/Search/v1/ProductsTab/helper.js
var ProductsTab_helper = __webpack_require__(34955);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/ProductList/v2/ProductList.jsx









const ProductListView = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(8279), __webpack_require__.e(1673), __webpack_require__.e(3284), __webpack_require__.e(752), __webpack_require__.e(7169), __webpack_require__.e(5230), __webpack_require__.e(4172), __webpack_require__.e(2464)]).then(__webpack_require__.bind(__webpack_require__, 12470)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(12470)
            ]
    }
});



const PLPLoader = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(498), __webpack_require__.e(6094)]).then(__webpack_require__.bind(__webpack_require__, 80498)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(80498)
            ]
    }
});












const ProductList = (props)=>{
    var ref;
    const isServer = "object" === "undefined";
    const isSsr = (0,useIsSsr/* default */.Z)();
    const router = (0,next_router.useRouter)();
    let plp;
    let compareData;
    const { eventHandler  } = props;
    const productsPerPage = constants.PRODUCTS_PER_PAGE;
    const DEFAULT_PAGINATION_VALUE = constants.DEFAULT_PRODUCT_COUNT_PLP;
    const { data: componentProps  } = props;
    const { access_token: accessToken , user  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { saveToListLineItems  } = (0,es/* useSelector */.v9)(favoritesSlice/* selectFavoritesState */.Qx);
    const { categoryKey , attributevalue , attributeName , isServiceParts =""  } = componentProps;
    if (isServer) {
        var ref1;
        plp = eventHandler === null || eventHandler === void 0 ? void 0 : (ref1 = eventHandler.store) === null || ref1 === void 0 ? void 0 : ref1.plp;
        compareData = {};
    } else {
        // eslint-disable-next-line
        plp = (0,es/* useSelector */.v9)(productListSlice/* selectProductListState */.rv).plp;
        // eslint-disable-next-line
        compareData = (0,es/* useSelector */.v9)(compareSlice/* compareState */.NP);
    }
    const productlistState = (0,es/* useSelector */.v9)(productListSlice/* selectProductListState */.rv);
    const { visualNavAppliedFilters =[]  } = productlistState;
    const dispatch = (0,es/* useDispatch */.I0)();
    const { data , total =0 , facets , facetLabels , status , initialLoad , colors , grouped , fusion ={}  } = plp;
    const rowsInitialValue = (0,product/* getRowsInitialValue */.U9)();
    const [paginationState, setPaginationState] = (0,react.useState)({
        rows: rowsInitialValue,
        start: 0
    });
    const { rows , start  } = paginationState;
    const [promoData, setPromoData] = (0,react.useState)({
        promos: [],
        isUpdate: false
    });
    const prevRows = (0,usePrevious/* default */.Z)(rows);
    const [isLoadMore, setIsLoadMore] = (0,react.useState)(false);
    const [general, setGeneral] = (0,react.useState)({
        brandName: "",
        badgeText: ""
    });
    const [sessionId, setSessionId] = (0,react.useState)("") // setting initial state of sessionId
    ;
    // Need to read from env file
    const [info, setInfo] = (0,react.useState)({
        currencyCode: "USD",
        currencySign: "$",
        locale: "en-US"
    });
    const [state, setState] = (0,react.useState)({
        position: "",
        promoJson: {}
    });
    const [caFrInitialFilterLoad, setCaFrInitialFilterLoad] = (0,react.useState)(false);
    const [caFrInitialFilters, setCaFrInitialFilters] = (0,react.useState)([]);
    const [fusionQueryId, setFusionQueryId] = (0,react.useState)("");
    const [curFilterQueries, setCurFilterQueries] = (0,react.useState)(null);
    const prevCurFilterQueries = (0,usePrevious/* default */.Z)(curFilterQueries);
    const [persona, setPersona] = (0,react.useState)("GST");
    const [isFusionLoaded, setIsFusionLoaded] = (0,react.useState)(false);
    const [dataPopulated, setDataPopulated] = (0,react.useState)(false);
    const [filterDataPopulated, setFilterDataPopulated] = (0,react.useState)(false);
    const [plpBadge, setPlpBadge] = (0,react.useState)({});
    const [filterCleared, setFilterCleared] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if (isSsr) return;
        (0,config/* getConfig */.i)().then((config)=>{
            const { plpConfigurations: { myArrayList: plpBadgeList = []  } = {}  } = config;
            const locale = get_default()(config, "internationalization.locale", "");
            const currencyCode = get_default()(config, "internationalization.currencyCode", "");
            const currencySign = get_default()(config, "internationalization.currencySign", "");
            const brandName = get_default()(config, "general.siteName");
            var ref;
            const displayOrderBadges = (ref = plpBadgeList.find((item)=>item.map.Key === "displayOrderBadges")) !== null && ref !== void 0 ? ref : {};
            const { map: { Values: { myArrayList: displayOrderBadgeList = []  } = {}  } = {}  } = displayOrderBadges;
            const plpBadges = {};
            displayOrderBadgeList.forEach((item)=>{
                plpBadges[item] = (0,helper.getBadgeValue)(item, plpBadgeList);
            });
            const badgeText = {
                new: get_default()(config, "general.newBadgeName", ""),
                onSale: get_default()(config, "general.saleBadgeName", ""),
                exclusive: get_default()(config, "general.exclusiveBadgeName", "")
            };
            const marketParamValues = get_default()(config, "marketParamValues", {});
            const { general: { serviceParts =""  } = {}  } = config;
            const general = {
                brandName: brandName,
                badgeText: badgeText,
                serviceParts
            };
            const info = {
                locale: locale,
                currencyCode: currencyCode,
                currencySign: currencySign,
                marketParamValues
            };
            const filterQuery = (0,helper.getAllFilterQueries)(componentProps, fusion, marketParamValues);
            const urlParams = window.location.search;
            if (locale === "fr-CA" && urlParams && !caFrInitialFilterLoad) {
                setCaFrInitialFilters([
                    ...filterQuery
                ]);
                generateListingUrl(false, true, true);
            } else {
                dispatch((0,productListSlice/* setCurrentAppliedfilters */.Li)(filterQuery));
                setCurFilterQueries(filterQuery);
            }
            setGeneral(general);
            setInfo(info);
            setPlpBadge({
                plpBadges,
                displayOrderBadgeList
            });
            const cookie = document === null || document === void 0 ? void 0 : document.cookie;
            const cookieArray = cookie === null || cookie === void 0 ? void 0 : cookie.split(";");
            const sessionCookie = cookieArray.filter((item)=>{
                return item === null || item === void 0 ? void 0 : item.includes("session#");
            })[0];
            const sessionIdString = sessionCookie === null || sessionCookie === void 0 ? void 0 : sessionCookie.split("|")[1];
            setSessionId(sessionIdString === null || sessionIdString === void 0 ? void 0 : sessionIdString.split("#")[1]) // setting the value of session id from cookie information
            ;
        });
    }, [
        isSsr,
        router
    ]);
    (0,react.useEffect)(()=>{
        if (visualNavAppliedFilters.length) {
            if (visualNavAppliedFilters[0].add) {
                setCurFilterQueries(visualNavAppliedFilters);
            } else {
                if (curFilterQueries) {
                    const finalFilters = [];
                    curFilterQueries.forEach((filter)=>{
                        var ref, ref1;
                        if ((filter === null || filter === void 0 ? void 0 : filter.facet) === ((ref = visualNavAppliedFilters[0]) === null || ref === void 0 ? void 0 : ref.facet) && (filter === null || filter === void 0 ? void 0 : filter.value.length) > visualNavAppliedFilters[0].value.length) {
                            var ref2, ref3;
                            const display = filter === null || filter === void 0 ? void 0 : filter.display;
                            const completeValues = filter === null || filter === void 0 ? void 0 : filter.value;
                            const displayValues = [
                                ...display
                            ];
                            const values = [
                                ...completeValues
                            ];
                            const indexDis = displayValues.indexOf((ref2 = visualNavAppliedFilters[0]) === null || ref2 === void 0 ? void 0 : ref2.display[0]);
                            const indexVal = values.indexOf((ref3 = visualNavAppliedFilters[0]) === null || ref3 === void 0 ? void 0 : ref3.value[0]);
                            if (indexDis !== -1) {
                                displayValues.splice(indexDis, 1);
                            }
                            if (indexVal !== -1) {
                                values.splice(indexVal, 1);
                            }
                            finalFilters.push({
                                ...filter,
                                display: displayValues,
                                value: values
                            });
                        } else if ((filter === null || filter === void 0 ? void 0 : filter.facet) !== ((ref1 = visualNavAppliedFilters[0]) === null || ref1 === void 0 ? void 0 : ref1.facet)) {
                            finalFilters.push(filter);
                        }
                    });
                    setCurFilterQueries(finalFilters);
                }
            }
        }
    }, [
        visualNavAppliedFilters
    ]);
    (0,react.useEffect)(()=>{
        if (caFrInitialFilterLoad) {
            var ref;
            const facetKyes = (ref = Object.keys(facetLabels)) !== null && ref !== void 0 ? ref : [];
            const caQueryFilters = caFrInitialFilters.map((filter)=>{
                const filterkey = facetKyes.find((facetKey)=>{
                    return facetLabels[facetKey] === filter.facet.replaceAll("_", " ");
                });
                return {
                    ...filter,
                    ...filterkey && {
                        facet: filterkey
                    }
                };
            });
            setCurFilterQueries(caQueryFilters !== null && caQueryFilters !== void 0 ? caQueryFilters : []);
        }
    }, [
        caFrInitialFilterLoad
    ]);
    const staticTexts = i18n_useProductListi18n({
        componentProps,
        total: total,
        generalRef: general
    });
    const [selectedSort, setSelectedSort] = (0,react.useState)({
        name: staticTexts.featured,
        query: ""
    });
    const prevSort = (0,usePrevious/* default */.Z)(selectedSort);
    const sorts = [
        {
            name: staticTexts.featured,
            query: ""
        },
        {
            name: staticTexts.priceDesc,
            query: "price+desc"
        },
        {
            name: staticTexts.priceAsc,
            query: "price+asc"
        },
        {
            name: staticTexts.atoz,
            query: "".concat(grouped ? "CollapseSort_s+asc" : "NonCollapseSort_s+asc")
        },
        {
            name: staticTexts.ztoa,
            query: "".concat(grouped ? "CollapseSort_s+desc" : "NonCollapseSort_s+desc")
        }
    ];
    const handleSort = (selectedSort)=>{
        (0,helper.replaceSearchUrl)("sort", selectedSort.query);
        setPaginationState((state)=>({
                ...state,
                start: 0
            }));
        setSelectedSort(selectedSort);
    };
    const handleLoadMore = ()=>{
        setRowsSession(start + rows + rows);
        setPaginationState((state)=>({
                ...state,
                start: start + rows
            }));
        setIsLoadMore(true);
    };
    const setRowsSession = (rows)=>{
        if (sessionStorage.rows) {
            const rowStorage = JSON.parse(sessionStorage.rows);
            rowStorage[window.location.pathname] = rows;
            sessionStorage.rows = JSON.stringify(rowStorage);
        } else {
            sessionStorage.rows = JSON.stringify({
                [window.location.pathname]: rows
            });
        }
    };
    const handleRows = (rows)=>{
        setPaginationState({
            rows,
            start: 0
        });
        setRowsSession(rows);
    };
    (0,react.useEffect)(()=>{
        if (accessToken && curFilterQueries !== null) {
            var ref, ref1;
            const personaTemp = (user === null || user === void 0 ? void 0 : (ref = user.persona) === null || ref === void 0 ? void 0 : ref.length) > 0 ? (ref1 = user === null || user === void 0 ? void 0 : user.persona[0]) === null || ref1 === void 0 ? void 0 : ref1.split(":")[1] : "GST";
            setPersona(personaTemp);
            window.authAccessToken = accessToken;
            // will trigger from handleLoadMore
            if (start) {
                generateListingUrl(isLoadMore, false);
            } else if (start === 0 && rows && !!prevRows && prevRows > rows) {
                generateListingUrl(false, true);
            } else if (start === 0 && rows && !!prevRows && prevRows !== rows) {
                generateListingUrl(false, false);
            } else if (curFilterQueries.length > 0 || (selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.query)) {
                generateListingUrl();
            } else if (curFilterQueries.length === 0 && prevCurFilterQueries !== null) {
                generateListingUrl();
            } else if (prevSort && (prevSort === null || prevSort === void 0 ? void 0 : prevSort.query) !== (selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.query)) {
                generateListingUrl();
            } else if (prevRows === rows && rows > DEFAULT_PAGINATION_VALUE || personaTemp !== "GST") {
                generateListingUrl();
            } else if ((curFilterQueries === null || curFilterQueries === void 0 ? void 0 : curFilterQueries.length) === 0) {
                generateListingUrl();
            }
        }
    }, [
        start,
        rows,
        accessToken,
        curFilterQueries,
        selectedSort,
        isLoadMore
    ]);
    (0,react.useEffect)(()=>{
        if (!(attributevalue && attributeName)) {
            if (!data || data && data.length === 3 && total > 3) {
                generateListingUrl();
            }
        }
    }, [
        data,
        total,
        attributevalue,
        attributeName
    ]);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(fusion) && accessToken && !isFusionLoaded) {
            setIsFusionLoaded(true);
            const fusionQueryId = fusion === null || fusion === void 0 ? void 0 : fusion.fusionQueryId;
            setFusionQueryId(fusionQueryId);
            const sortUrl = (0,helper.getSortFromUrl)();
            const sortQuery = (0,helper.getSelectedSort)(staticTexts, sortUrl);
            setSelectedSort(sortQuery);
            if (componentProps && (componentProps === null || componentProps === void 0 ? void 0 : componentProps.xfLink)) {
                setState({
                    ...state,
                    xfHtml: componentProps.xfLink
                });
            }
        }
    }, [
        fusion,
        accessToken
    ]);
    // Function to generate the plp request url.
    const generateListingUrl = async function(update) {
        let enableScroll = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, initialCaFr = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        const queries = curFilterQueries;
        if (!update) {
            setPaginationState({
                ...paginationState,
                start: 0
            });
            setPromoData({
                promos: [],
                isUpdate: false
            });
        }
        const fq = [];
        const persona = (0,helper.getUserPersona)();
        queries === null || queries === void 0 ? void 0 : queries.forEach((q)=>{
            var ref;
            const tag = '{!tag="'.concat(q.facet, '"}');
            if (!q.facet.match(/^\*{2}/)) {
                var ref1;
                q.facet === "Price_Range" || q.facet.indexOf("priceList") === 0 || ((ref1 = q.facet) === null || ref1 === void 0 ? void 0 : ref1.indexOf("discountedPriceStartingAt")) === 0 ? fq.push(encodeURIComponent("".concat('{!tag="priceList.'.concat(persona, '.finalPrice_d"}') + "priceList.".concat(persona, ".finalPrice_d"), ":(").concat(q.value.join(" OR "), ")"))) : fq.push(encodeURIComponent("".concat(tag + q.facet, ':("').concat(q.value.join('" OR "'), '")')));
                return;
            }
            q.facet === "Price_Range" || q.facet.indexOf("priceList") === 0 || ((ref = q.facet) === null || ref === void 0 ? void 0 : ref.indexOf("discountedPriceStartingAt")) === 0 ? fq.push("".concat("priceList.".concat(persona, ".finalPrice_d").replace(/^\*{2}/, ""), ":(").concat(encodeURIComponent(q.value), ")")) : fq.push("".concat(q.facet.replace(/^\*{2}/, ""), ':("').concat(encodeURIComponent(q.value.join('","')), '")'));
        });
        const query = {
            fq,
            rows,
            start,
            fl: constants.resourceFacetLabels.join(",")
        };
        if (selectedSort.query) {
            if (selectedSort.query === "price+asc") {
                query.sort = "".concat((0,helper.getPriceSortQuery)(plp === null || plp === void 0 ? void 0 : plp.grouped), "+asc");
            } else if (selectedSort.query === "price+desc") {
                query.sort = "".concat((0,helper.getPriceSortQuery)(plp === null || plp === void 0 ? void 0 : plp.grouped), "+desc");
            } else {
                query.sort = selectedSort.query;
            }
        }
        if (enableScroll) setDataPopulated(false);
        const globalConfig = await (0,config/* getConfig */.i)();
        const { general: { serviceParts =""  } = {}  } = globalConfig;
        const collections = isServiceParts ? serviceParts : "";
        dispatch((0,productListSlice/* getProducts */.Xp)({
            profileName: categoryKey,
            query,
            update,
            collections
        })).then(()=>{
            setFilterDataPopulated(true);
            if (initialCaFr) setCaFrInitialFilterLoad(true);
            if (enableScroll) setDataPopulated(true);
        }).catch(()=>{
            setFilterDataPopulated(true);
            if (enableScroll) setDataPopulated(false);
        });
    };
    const setPromoInfo = (promo)=>{
        const promoDataNew = [
            ...promoData.promos
        ];
        if (promo && !promoData.promos.find((item)=>item.position === promo.position)) {
            // don't push duplicates
            promoDataNew.push(promo);
        }
        setPromoData({
            promos: promoDataNew,
            isUpdate: true
        });
    };
    (0,react.useEffect)(()=>{
        // checking if all responses are recorded
        if (isSsr) return;
        const { isUpdate , promos  } = promoData;
        if (isUpdate) {
            const { position  } = state;
            const requestedPromos = [];
            data.map((item, i)=>{
                if ((i + 1) % position === 0) {
                    requestedPromos.push(i);
                }
            });
            if (requestedPromos.length === promos.length) {
                addAnalyticsShowEvent(promos, setPromoData, data);
            }
        }
    }, [
        promoData.promos,
        promoData.isUpdate,
        isSsr
    ]);
    (0,react.useEffect)(()=>{
        if (isSsr) return;
        // plpLoadedEvent implementation
        const { position , xfHtml  } = state;
        const { promos  } = promoData;
        if (!data || !data.length || parseInt(data.length / position) === 0 || !xfHtml) {
            addAnalyticsShowEvent(promos, setPromoData, data);
        } else {
            // checking if all responses are recorded
            const requestedPromos = [];
            data.map((item, i)=>{
                if ((i + 1) % position === 0) {
                    requestedPromos.push(i);
                }
            });
            if (requestedPromos.length === 0) {
                addAnalyticsShowEvent(promos, setPromoData, data);
            } else {
                const timeoutId = setTimeout(()=>{
                    addAnalyticsShowEvent(promos, setPromoData, data);
                }, 5000);
                return ()=>{
                    clearTimeout(timeoutId);
                };
            }
        }
    }, [
        data,
        state.position,
        componentProps.xfLink,
        isSsr
    ]);
    (0,react.useEffect)(()=>{
        const urlParams = new URLSearchParams(window.location.search);
        const facetParam = urlParams.get("facets");
        // To scrollup the product list on back
        if (document.querySelector(".visual-nav")) {
            if (window.location.search.includes("&back") && window.location.search.includes("?facets") || dataPopulated && facetParam || window.location.search.includes("?facets") || filterCleared) {
                (0,ProductsTab_helper/* scrollToVisualNav */.qL)();
            }
        } else if (dataPopulated && facetParam && !document.querySelector(".visual-nav") || filterCleared && !document.querySelector(".visual-nav")) {
            (0,ProductsTab_helper/* scrollToFirstProduct */.nj)(false, true);
        } else if (window.location.search.includes("?") && !window.location.search.includes("?back") && !window.location.search.includes("?facets")) {
            scrollToTop();
        } else if (dataPopulated) {
            (0,ProductsTab_helper/* scrollToProduct */.C1)();
        }
    }, [
        dataPopulated,
        filterCleared
    ]);
    const scrollToTop = ()=>{
        window.scrollTo(0, 0);
    };
    const sendPositionToParent = (position)=>{
        setState({
            ...state,
            position: position
        });
    };
    const handleFilter = (appliedFilter)=>{
        setRowsSession(30);
        setIsLoadMore(false);
        setFilterCleared(!appliedFilter.length);
        setCurFilterQueries(appliedFilter);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !isEmpty_default()(info) && (!(attributeName && attributevalue) || attributevalue && attributeName && filterDataPopulated) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            "data-testid": "product-list",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListView, {
                staticTexts: staticTexts,
                sorts: sorts,
                selectedSort: selectedSort,
                info: info,
                onLoadMore: handleLoadMore,
                curRows: rows,
                onRows: handleRows,
                onSort: handleSort,
                onFilter: handleFilter,
                totalResults: total,
                displayShare: componentProps.enableSharePlp,
                displayPrint: componentProps.enablePrintPlp,
                productsPerPage: productsPerPage,
                data: data,
                colors: colors,
                loading: initialLoad ? false : status !== "succeeded",
                ...componentProps,
                facets: facets !== null && facets !== void 0 ? facets : false,
                facetLabels: facetLabels,
                xfHtml: state.xfHtml,
                currFilters: curFilterQueries,
                // resetTitle={""} The value is not using any where, so not implemented now
                // urlTitle={""} The value is not using any where, so not implemented now
                isGrouped: grouped,
                favorites: (ref = (0,helper.getFavouraties)()) === null || ref === void 0 ? void 0 : ref.lineItems,
                setPromoData: setPromoInfo,
                sendPositionToParent: sendPositionToParent,
                promoData: promoData.promos,
                promoJson: (componentProps === null || componentProps === void 0 ? void 0 : componentProps.xfjson) ? JSON.parse(componentProps === null || componentProps === void 0 ? void 0 : componentProps.xfjson) : {},
                fusionQueryId: fusionQueryId,
                parent: "PLP",
                compareData: compareData,
                promoLayout: componentProps === null || componentProps === void 0 ? void 0 : componentProps.promoLayout,
                promoPlacementDesktop: componentProps === null || componentProps === void 0 ? void 0 : componentProps.promoPlacementDesktop,
                promoPlacementMobile: componentProps === null || componentProps === void 0 ? void 0 : componentProps.promoPlacementMobile,
                persona: persona,
                sessionId: sessionId,
                plpBadge: plpBadge,
                savedListLineItems: saveToListLineItems
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((ProductListView_index_module_default()).productListWrapper, " ").concat((ProductTile_index_module_default()).productTileWrapper, " ").concat((index_module_default()).productListingSearchWrapper, " ").concat((Filter_index_module_default()).productListingFilterWrapper),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PLPLoader, {})
        })
    });
};
/* harmony default export */ var v2_ProductList = (ProductList);


/***/ }),

/***/ 34955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C1": function() { return /* binding */ scrollToProduct; },
/* harmony export */   "c9": function() { return /* binding */ getFlData; },
/* harmony export */   "n4": function() { return /* binding */ handleKeyPress; },
/* harmony export */   "nj": function() { return /* binding */ scrollToFirstProduct; },
/* harmony export */   "qL": function() { return /* binding */ scrollToVisualNav; },
/* harmony export */   "sR": function() { return /* binding */ getFilterQuery; },
/* harmony export */   "ur": function() { return /* binding */ getSortList; }
/* harmony export */ });
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96301);

const getSortList = (staticTexts)=>[
        {
            name: staticTexts.featured
        },
        {
            name: staticTexts.bestSellers,
            query: "bestSeller_l+asc"
        },
        {
            name: staticTexts.priceDesc,
            query: "price+desc"
        },
        {
            name: staticTexts.priceAsc,
            query: "price+asc"
        },
        {
            name: staticTexts.atoz,
            query: "productName_s+asc"
        },
        {
            name: staticTexts.ztoa,
            query: "productName_s+desc"
        }
    ];
const handleKeyPress = (e, width, filterRef, cb)=>{
    if (width < 992) {
        const focusElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), button:not([disabled]) [role="button]:not([hidden=true])';
        const focusContent = filterRef.current.querySelectorAll(focusElements);
        const firstElem = focusContent[0];
        const lastElem = focusContent[focusContent.length - 1].disabled ? focusContent[focusContent.length - 2] : focusContent[focusContent.length - 1];
        if (e.key === "Escape") {
            cb(false);
        }
        if (e.key === "Tab") {
            if (e.shiftKey && (document.activeElement === firstElem || document.activeElement === filterRef.current)) {
                e.preventDefault();
                lastElem.focus();
            }
            if (!e.shiftKey && document.activeElement === lastElem) {
                e.preventDefault();
                firstElem.focus();
            }
        }
    }
};
const scrollToProduct = ()=>{
    const urlParams = window.location.search;
    let queryVal = "";
    let isBackSkuExists = false;
    if (urlParams) {
        const urlQuery = urlParams.replace("?", "").split("&");
        urlQuery.forEach((query, i)=>{
            const isBack = query.split("=")[0] === "back";
            if (isBack) {
                sessionStorage.plpScrollSku = query.split("=")[1];
                isBackSkuExists = true;
            }
            queryVal += isBack ? "" : "".concat(i > 0 ? "&" : "").concat(query);
        });
        window.history.replaceState(window.location.pathname, document.title, queryVal.length > 0 ? "?".concat(queryVal.toString()) : window.location.pathname);
        if (sessionStorage.plpScrollSku) {
            const scrollPosition = document.getElementById(sessionStorage.plpScrollSku);
            let IterCount = 10;
            const scorllObjInterval = setInterval(()=>{
                if (scrollPosition) {
                    scrollPosition.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                        inline: "nearest"
                    });
                    if (IterCount === 0) {
                        delete sessionStorage.plpScrollSku;
                        clearInterval(scorllObjInterval);
                    }
                    IterCount--;
                }
            }, 150);
        } else if (!isBackSkuExists) {
            scrollToFirstProduct(false, true);
        }
    } else {
        scrollToTop();
    }
};
const scrollToFirstProduct = function() {
    let isFaq = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, shouldScroll = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    setTimeout(()=>{
        const scrollPositions = isFaq ? document.querySelectorAll("div.product-listing") : document.querySelectorAll(".product-listing");
        if (scrollPositions && scrollPositions.length > 0 && shouldScroll) {
            window.scrollTo({
                top: scrollPositions[0].offsetTop,
                behavior: "smooth"
            });
        } else {
            scrollToTop();
        }
    }, 200);
};
const scrollToVisualNav = ()=>{
    const timeoutId = setTimeout(()=>{
        const scrollPositions = document.querySelectorAll("div.filter-conatiner");
        if (scrollPositions && scrollPositions.length > 0) {
            window.scrollTo({
                top: scrollPositions[0].offsetTop,
                behavior: "smooth"
            });
        } else {
            scrollToTop();
        }
    }, 200);
    return ()=>{
        clearTimeout(timeoutId);
    };
};
const scrollToTop = ()=>{
    window.scrollTo(0, 0);
};
const getFlData = (persona)=>[
        "id",
        "sku_s",
        "slug_s",
        "metaTitle_s",
        "productName_s",
        "masterSKU_s",
        "masterCustomerFacingSKU_s",
        "Product_Category",
        "ProductLocalCategory_s",
        "ProductBrandName_s",
        "productImages.url_ss",
        "displayPriceStartingAt_s",
        "SKUColorSwatchFilename_ss",
        "ProductDescriptionProductShort_s",
        "priceList.".concat(persona, ".price_d"),
        "priceList.".concat(persona, ".finalPrice_d"),
        "priceList.".concat(persona, ".discountedPrice_d"),
        "priceList.".concat(persona, ".saleOffer_s"),
        "priceStartingAt.".concat(persona, "_d"),
        "discountedPriceStartingAt.".concat(persona, "_d"),
        "variantList.sku_ss",
        "Color.SKU.Details_ss",
        "Color.".concat(persona, ".Details_ss"),
        "ProductIsExclusive_s",
        "RegionReleaseforShipment_dt",
        "productImages.labelWithUrl_ss",
        "RegionOnBackOrder_s",
        "RegionBrandName_s",
        "ProductIsRetail",
        "comboSKUAvailable_b",
        "category1_s",
        "ProductBrandNameDisplay_s",
        "ctId_s",
        "ProductResource.InteractiveSVG.resourceName_ss",
        "ProductProductNo_s",
        "ProductResource.InteractiveSVG.resourceTitle_ss",
        "ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss",
        "ProductResource.PartsPDFFileName.resourceFullWebURL_ss",
        _constants_index__WEBPACK_IMPORTED_MODULE_0__.resourceFacetLabels.join(","),
        "primaryBundleSKU_s",
        "bundleSKUList_ss"
    ];
const getFilterQuery = function(type, query) {
    let queries = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], persona = arguments.length > 3 ? arguments[3] : void 0;
    const fq = type === "parts" ? [] : [
        query
    ];
    queries.forEach((q)=>{
        const tag = '{!tag="'.concat(q.facet, '"}');
        if (!q.facet.match(/^\*{2}/)) {
            q.facet === "Price_Range" ? fq.push(encodeURIComponent('{!tag="priceList.'.concat(persona, '.finalPrice_d"}priceList.').concat(persona, ".finalPrice_d:(").concat(q.value.join(" OR "), ")"))) : fq.push(encodeURIComponent("".concat(tag + q.facet, ':("').concat(q.value.join('" OR "'), '")')));
            return;
        }
        q.facet === "Price_Range" ? fq.push("priceList.".concat(persona, ".finalPrice_d:(").concat(encodeURIComponent(q.value), ")")) : fq.push("".concat(q.facet.replace(/^\*{2}/, ""), ':("').concat(encodeURIComponent(q.value.join('","')), '")'));
    });
    return fq;
};



/***/ }),

/***/ 48375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24899);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46201);
/* harmony import */ var _hooks_usePrevious__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67166);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55760);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11763);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2595);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19514);









const usePageAuth = ()=>{
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    const { access_token: accessToken  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .selectAuthState */ ._9);
    const { cart: activeCart , isCartLoading  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .selectCartState */ .xw);
    const prevToken = (0,_hooks_usePrevious__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        accessToken
    });
    // just for the dev testing purpose, if works fine then can only be proceed otherwise
    // one more pr will be raised to revert the change
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        let timeoutId;
        if (!isSsr) {
            timeoutId = setTimeout(()=>{
                if (!accessToken || !(0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.isGuestTokenValid)()) {
                    dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .getOktaToken */ .cs)("guest"));
                }
            }, 5000);
        }
        ;
        ()=>{
            clearTimeout(timeoutId);
        };
    }, [
        accessToken,
        isSsr
    ]);
    const callInitAuth = async ()=>{
        var ref;
        const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_8__/* .getConfig */ .i)();
        const disableCommerce = (config === null || config === void 0 ? void 0 : (ref = config.general) === null || ref === void 0 ? void 0 : ref.disableCommerce) || false;
        if (disableCommerce) return;
        const hasNoActiveCart = ()=>{
            return (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.isGuestTokenValid)() && accessToken && !(activeCart === null || activeCart === void 0 ? void 0 : activeCart.id) && !(activeCart === null || activeCart === void 0 ? void 0 : activeCart.cartExists);
        };
        if (hasNoActiveCart() || hasNoActiveCart() && (prevToken === null || prevToken === void 0 ? void 0 : prevToken.accessToken) !== accessToken) {
            if (!isCartLoading) {
                dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(true));
                dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .getCart */ .dv)()).unwrap().then((res)=>{
                    if ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.isGuestTokenValid)() && accessToken && (res === null || res === void 0 ? void 0 : res.cartExists) && (res === null || res === void 0 ? void 0 : res.cartExists) === "false" && (res === null || res === void 0 ? void 0 : res.error) === "No active cart exists.") {
                        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.getCurrency)().then((currency)=>{
                            const cartPayload = {
                                currency: currency,
                                taxMode: "ExternalAmount"
                            };
                            dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .createCart */ .Bk)(cartPayload)).unwrap().then(()=>{
                                dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(false));
                            });
                        });
                    } else {
                        dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(false));
                    }
                });
            }
        }
        (0,_utils_cart__WEBPACK_IMPORTED_MODULE_6__/* .setCartLandingPagePath */ .NS)();
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (isSsr) return;
        callInitAuth();
    }, [
        accessToken,
        isSsr
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (usePageAuth);


/***/ }),

/***/ 67166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const usePrevious = (value)=>{
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
};
/* harmony default export */ __webpack_exports__["Z"] = (usePrevious);


/***/ }),

/***/ 32020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51857);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9473);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24400);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(55760);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11763);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(88751);
/* harmony import */ var _hooks_usePageAuth__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(48375);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(46201);
/* harmony import */ var _components_ProductList_v2_ProductList__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(50064);
/* harmony import */ var _store_features_productListSlice__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(49682);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(2595);
/* harmony import */ var _components_ProductList_v2_ProductListView_index_module_scss__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(29472);
/* harmony import */ var _components_ProductList_v2_ProductListView_index_module_scss__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_components_ProductList_v2_ProductListView_index_module_scss__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _components_ProductList_v2_ProductTile_index_module_scss__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(50702);
/* harmony import */ var _components_ProductList_v2_ProductTile_index_module_scss__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_components_ProductList_v2_ProductTile_index_module_scss__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_17__);





















const BreadCrumb = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>__webpack_require__.e(/* import() */ 3282).then(__webpack_require__.bind(__webpack_require__, 3282)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(3282)
            ]
    }
});
const AemGrid = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 62429)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(62429)
            ]
    }
});
const GlobalPageHeader = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 81169)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(81169)
            ]
    }
});
const GlobalPageFooter = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 10884)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10884)
            ]
    }
});
const PLPLoader = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.all(/* import() */[__webpack_require__.e(498), __webpack_require__.e(6094)]).then(__webpack_require__.bind(__webpack_require__, 80498)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(80498)
            ]
    }
});
const UpSellInstallServices = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.all(/* import() */[__webpack_require__.e(6066), __webpack_require__.e(3284), __webpack_require__.e(752), __webpack_require__.e(9348), __webpack_require__.e(4075), __webpack_require__.e(154)]).then(__webpack_require__.bind(__webpack_require__, 61054)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(61054)
            ]
    }
});
const ProductAccordion = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>__webpack_require__.e(/* import() */ 7289).then(__webpack_require__.bind(__webpack_require__, 87289)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(87289)
            ]
    }
});
/**
 * renders home page
 * @return {JSX.Element}
 * @param {object} props The props.
 */ const Listing = (props)=>{
    var ref;
    const { tmpData: data , headertmp: header , footertmp: footer , ip , adobeAnalytic , globalScript , footerScript , analyticsData , datalayerPageName , plpData , gbhDataLayerCustom , canonicalUrl ="" , seoPageScript ="" , breadCrumbApplicationJSonLd ="" , seoProperties , pageData , siteName , templateName =""  } = props;
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$G)("common");
    const language = (0,next_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$G)();
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)();
    const { cartUrl  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_13__/* .selectCartState */ .xw);
    const [pageRedirect, setPageRedirect] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)("");
    const [seoScripts, setSeoScripts] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]);
    const { redirectTarget: { page: { path =""  } = {}  } = {}  } = data;
    const { brandLogoImg , menu: { isOpen , mainCategoryActive , isRegionOpen , isAuthNavOpen  }  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_11__.selectGenericState);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        if (ip) sessionStorage.setItem("true-ip", ip);
    }, [
        ip
    ]);
    (0,_hooks_usePageAuth__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)();
    const cartCount = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_10__/* .getCartCount */ .c0)();
    const ariaLabel = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_10__/* .getAriaLabel */ .Xw)(t, cartCount);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        footer && (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__.getScriptsAndStyles)(footer);
        adobeAnalytic && (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__.getAnalyticsScript)(adobeAnalytic);
        analyticsData && (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__.getDataLayerObj)(analyticsData);
        path && setPageRedirect((0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__.removeAndCleanLink)(path));
    }, [
        footer,
        adobeAnalytic,
        analyticsData,
        path
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        if (!isSsr && pageRedirect) {
            router.push(pageRedirect);
        }
    }, [
        isSsr,
        pageRedirect
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_11__.setDatalayerPageName)(datalayerPageName));
        dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_11__.setGbhDataLayerCustom)(gbhDataLayerCustom));
        plpData && dispatch((0,_store_features_productListSlice__WEBPACK_IMPORTED_MODULE_15__/* .setPlpData */ .gS)({
            ...plpData,
            status: "succeeded",
            initialLoad: true
        }));
        return ()=>{
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_11__.setDatalayerPageName)(""));
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_11__.setGbhDataLayerCustom)(""));
        };
    }, [
        datalayerPageName,
        gbhDataLayerCustom,
        plpData
    ]);
    const pageUrl = new URL(pageData === null || pageData === void 0 ? void 0 : pageData.pageUrl);
    var _origin;
    const originUrl = (_origin = pageUrl.origin) !== null && _origin !== void 0 ? _origin : "";
    const toggleMenu = ()=>{
        if (isOpen) {
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_11__.closeMenu)());
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_11__.setAuthNav)(false));
        } else {
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_11__.openMenu)());
        }
    };
    const redirect = ()=>{
        router.push("".concat(cartUrl));
    };
    const eventHandler = {
        store: {
            brandLogoImg: brandLogoImg,
            isOpen,
            mainCategoryActive,
            isRegionOpen,
            isAuthNavOpen,
            cartCount,
            ariaLabel,
            cartUrl,
            plp: {
                ...plpData,
                status: "succeeded"
            }
        },
        callbacks: {
            setBrandLogoImg: (path)=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_11__.setBrandLogoImg)(path));
            },
            closeMenu: ()=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_11__.closeMenu)());
            },
            setMainCategory: (payload)=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_11__.setActiveMainCategory)(payload));
            },
            toggleMenu: ()=>{
                toggleMenu();
            },
            setRegionNav: (active)=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_11__.setRegionNav)(active));
            },
            setAuthNav: (active)=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_11__.setAuthNav)(active));
            },
            setGlobalScripts: (item)=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_11__.setGlobalScripts)(item));
            },
            setGlobalStyles: (item)=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_11__.setGlobalStyles)(item));
            },
            onClick: ()=>{
                redirect();
            }
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        seoPageScript && extractSeoPageScript(seoPageScript);
    }, [
        seoPageScript
    ]);
    const extractSeoPageScript = function() {
        let scriptContent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        const scriptList = [];
        const doc = new DOMParser().parseFromString(scriptContent, "text/html");
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__.extractScriptsFromDOM)(doc, (item)=>scriptList.push(item));
        setSeoScripts(scriptList);
    };
    var ref1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_7___default()), {
                children: [
                    canonicalUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: (language === null || language === void 0 ? void 0 : (ref = language.i18n) === null || ref === void 0 ? void 0 : ref.language) === "fr" ? canonicalUrl === null || canonicalUrl === void 0 ? void 0 : canonicalUrl.replace("/en/", "/fr/") : canonicalUrl
                    }) : null,
                    breadCrumbApplicationJSonLd && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_17___default().sanitize(breadCrumbApplicationJSonLd)
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GlobalPageHeader, {
                        header: header,
                        title: data.title,
                        globalScripting: globalScript,
                        fullUrl: canonicalUrl,
                        siteName: siteName,
                        phone: seoProperties === null || seoProperties === void 0 ? void 0 : seoProperties.phoneNum,
                        imageUrl: templateName === "category-landing-page" ? pageData === null || pageData === void 0 ? void 0 : pageData.thumbnailImageUrl : (ref1 = "".concat(originUrl, "/_next/static/media/BLOK_LOGO.00edf835.svg")) !== null && ref1 !== void 0 ? ref1 : "",
                        description: data === null || data === void 0 ? void 0 : data.description
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                        id: "4da4082d098430d2",
                        children: "@media print{@page{size:A4 portrait!important}}"
                    }),
                    seoScripts.map((script, i)=>!script.src && script.innerHTML ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_8___default()), {
                            id: "seoscript-".concat(i),
                            type: script.type,
                            "data-script-purpose": "seo",
                            children: "".concat(script.innerHTML)
                        }, "seoscript-".concat(i)) : null),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        id: data.id,
                        className: "jsx-4da4082d098430d2" + " " + (data.cssClassNames || ""),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AemGrid, {
                            data: data,
                            count: 0,
                            eventHandler: eventHandler,
                            breadCrumb: (data, fullData)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BreadCrumb, {
                                    data: data,
                                    fullData: fullData,
                                    plpPage: true
                                }),
                            productAccordion: (data, fullData)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductAccordion, {
                                    data: data,
                                    fullData: fullData
                                }),
                            productList: (data, eventHandler)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductList_v2_ProductList__WEBPACK_IMPORTED_MODULE_14__["default"], {
                                    data: data,
                                    eventHandler: eventHandler
                                }),
                            productListFiller: ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "jsx-4da4082d098430d2" + " " + "".concat((_components_ProductList_v2_ProductListView_index_module_scss__WEBPACK_IMPORTED_MODULE_18___default().productListWrapper), " ").concat((_components_ProductList_v2_ProductTile_index_module_scss__WEBPACK_IMPORTED_MODULE_19___default().productTileWrapper)),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PLPLoader, {})
                                }),
                            upSellContainer: (data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UpSellInstallServices, {
                                    authData: data
                                })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GlobalPageFooter, {
                        footer: footer,
                        footerScripting: footerScript
                    })
                ]
            })
        ]
    });
};
Listing.propTypes = {
    tmpData: (prop_types__WEBPACK_IMPORTED_MODULE_20___default().any),
    headertmp: (prop_types__WEBPACK_IMPORTED_MODULE_20___default().any),
    footertmp: (prop_types__WEBPACK_IMPORTED_MODULE_20___default().any),
    ip: (prop_types__WEBPACK_IMPORTED_MODULE_20___default().any),
    adobeAnalytic: (prop_types__WEBPACK_IMPORTED_MODULE_20___default().any),
    globalScript: (prop_types__WEBPACK_IMPORTED_MODULE_20___default().any),
    footerScript: (prop_types__WEBPACK_IMPORTED_MODULE_20___default().any),
    analyticsData: (prop_types__WEBPACK_IMPORTED_MODULE_20___default().any),
    datalayerPageName: (prop_types__WEBPACK_IMPORTED_MODULE_20___default().any),
    plpData: (prop_types__WEBPACK_IMPORTED_MODULE_20___default().any),
    gbhDataLayerCustom: (prop_types__WEBPACK_IMPORTED_MODULE_20___default().any),
    canonicalUrl: (prop_types__WEBPACK_IMPORTED_MODULE_20___default().string),
    seoPageScript: (prop_types__WEBPACK_IMPORTED_MODULE_20___default().string),
    breadCrumbApplicationJSonLd: (prop_types__WEBPACK_IMPORTED_MODULE_20___default().string)
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Listing);


/***/ }),

/***/ 3899:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productListingFilterWrapper":"Filter_productListingFilterWrapper__Lmvl4","load":"Filter_load___YijE"};

/***/ }),

/***/ 29472:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productListWrapper":"ProductListView_productListWrapper__KS0NK"};

/***/ }),

/***/ 50702:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productTileWrapper":"ProductTile_productTileWrapper__SFQ2t"};

/***/ }),

/***/ 19806:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productListingSearchWrapper":"Sort_productListingSearchWrapper__mFgMi"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5979,1976,7783,9774,2888,179], function() { return __webpack_exec__(40336); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);